import React from "react";
import MealSection from "./MealSection";
import DayOperationsMenu from "./DayOperationsMenu";

const DayColumn = React.memo(({ 
  day, 
  recipes, 
  dayTotals, 
  onViewRecipe, 
  onEditRecipe, 
  onDeleteRecipe, 
  currentPlanType,
  onCopyDay,
  onClearDay,
  onClearMeal
}) => {
  const meals = ["Breakfast", "Lunch", "Appetizer", "Dinner", "Dessert", "Snack", "Other"];
  const totals = dayTotals[day] || { calories: "0", cost: "0" };
  
  // Check if this is today - only show for current week
  const today = new Date();
  const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const isToday = currentPlanType === 'current' && day === dayNames[today.getDay()];
  
  // Check if day has recipes
  const dayRecipes = recipes.filter(recipe => recipe.day === day);
  const hasRecipes = dayRecipes.length > 0;

  return (
    <div className="col-sm-6 col-md-4 col-lg-3 day-column">
      <div className={`card day-card ${isToday ? 'is-today' : ''}`}>
        <div className="day-header">
          <div className="day-header-top">
            <h3 className="day-name">{day}</h3>
            {(onClearDay || onClearMeal) && (
              <DayOperationsMenu
                day={day}
                onCopyDay={onCopyDay}
                onClearDay={onClearDay}
                onClearMeal={onClearMeal}
                hasRecipes={hasRecipes}
                meals={meals}
                currentPlanType={currentPlanType}
              />
            )}
          </div>
          <div className="day-totals">
            <div className="total-item">
              <span className="total-label">Calories</span>
              <span className="total-value">{totals.calories}</span>
            </div>
            <div className="total-item">
              <span className="total-label">Cost</span>
              <span className="total-value">${parseFloat(totals.cost).toFixed(2)}</span>
            </div>
          </div>
        </div>
        <div className="day-body">
          {meals.map((meal) => (
            <MealSection
              key={`${day}-${meal}`}
              day={day}
              meal={meal}
              recipes={recipes}
              onViewRecipe={onViewRecipe}
              onEditRecipe={onEditRecipe}
              onDeleteRecipe={onDeleteRecipe}
            />
          ))}
        </div>
      </div>
    </div>
  );
});

export default DayColumn;